import * as React from 'react';
import { Typography, Row, Col, Divider, Button } from 'antd';
import { MailOutlined, PhoneOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useParams, Link } from 'react-router-dom';
import AppointmentsTable from '../components/AppointmentsTable';
import MainLayout from './layouts/MainLayout';
import CertificatesTable from '../components/CertificatesTable';
import CertificateModal from '../components/CertificateModal';

const { Title } = Typography;

type Params = {
  id: string;
};

type Student = {
  _id: string;
  appointments: Object[];
  certificates: Object[];
  email: string;
  firstName: string;
  lastName: string;
  lastCoupon: string;
  phone: string;
  wordpressId: number;
};

export default function SingleStudentScreen() {
  const { id }: Params = useParams();
  const [student, setStudent] = React.useState<Student>();
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Get the student
  React.useEffect(() => {
    axios
      .get(`/api/student/${id}`)
      .then((res) => {
        setStudent(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  return (
    <MainLayout>
      <CertificateModal
        singleStudent
        student={student}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      />
      <Row>
        <Col span={12}>
          <Title level={3}>
            {student?.firstName} {student?.lastName}
          </Title>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Button type="primary" onClick={showModal}>
            Assign Certificate
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          {student?.email ? (
            <span className="details-icon">
              <MailOutlined /> {student?.email}
            </span>
          ) : null}
          {student?.phone ? (
            <span className="details-icon">
              <PhoneOutlined /> {student?.phone}
            </span>
          ) : null}
        </Col>
      </Row>
      <Divider />
      <Row className="student-certificates student-table">
        <Col span={24}>
          <Title level={4}>Certificates</Title>
          {student?.certificates?.[0] ? (
            <div className="responsive-table">
              <CertificatesTable certificates={student?.certificates} />
            </div>
          ) : null}
        </Col>
      </Row>
      <Row className="student-appointments student-table">
        <Col span={24}>
          <Title level={4}>Appointment History</Title>
          {student?.appointments?.[0] ? (
            <div className="responsive-table">
              <AppointmentsTable appointments={student?.appointments} />
            </div>
          ) : null}
        </Col>
      </Row>
    </MainLayout>
  );
}
